import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { get } from 'lodash';

import ThirdPartyScriptsWrapper from '../components/ThirdPartyScriptsWrapper';

export default withRouter(connect(
  state => ({
    shouldBlockThirdPartyScripts: state.user.betaFeatures.includes('BLOCK_THIRD_PARTY_SCRIPTS'),
    thirdPartyScriptsRestrictedPages: get(state, 'properties.thirdPartyScriptsRestrictedPages'),
  })
)(ThirdPartyScriptsWrapper));
